module.exports = __webpack_public_path__ + "static/media/instruction_for_calling_mb.e1b78af0.png";